module.exports = __webpack_public_path__ + "static/media/logo-comune-prignano.b6386fdf.webp";